import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import { Progress as SemanticProgress } from 'semantic-ui-react';

const FileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 5px 0;
  gap: 5px
`;

const Text = styled(TextLayoutComponent)`
  text-align: left;
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 190px;
`;

const UploadedText = styled(TextLayoutComponent)`
  text-align: center;
  color: #05770D;
`;

const Progress = styled(SemanticProgress)`
  &&& {
    width: 90%;
    align-self: center;
    margin: 0;
  }
`;

const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const PercentageText = styled(TextLayoutComponent)`
  width: 30px;
  text-align: center;
`;

const Error = styled(TextLayoutComponent)`
  text-align: center;
  color: red;
`;

export {
  FileContainer,
  PercentageText,
  Progress,
  ProgressWrapper,
  Text,
  TextWrapper,
  UploadedText,
  Error,
};
